import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useState } from 'react';

interface FractionalizeAssetModalProps {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  onConfirm: (payload: { totalFractions: number; pricePerFraction: number }) => void;
}

export function FractionalizeAssetModal({
  open,
  onClose,
  onConfirm,
  loading,
}: FractionalizeAssetModalProps) {
  const [totalFractions, setTotalFractions] = useState('');
  const [pricePerFraction, setPricePerFraction] = useState('');

  const handleCloseModal = () => {
    setTotalFractions('');
    setPricePerFraction('');
    onClose();
  };

  const handleSubmit = () => {
    onConfirm({
      totalFractions: Number(totalFractions),
      pricePerFraction: Number(pricePerFraction),
    });

    setTotalFractions('');
    setPricePerFraction('');
  };

  return (
    <Dialog open={open} onOpenChange={handleCloseModal}>
      <DialogContent className="max-w-md border border-input">
        <DialogHeader>
          <DialogTitle>Fractionalize Asset</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Total Fractions</Label>
            <Input
              type="number"
              inputMode="numeric"
              placeholder="Enter total fractions"
              value={totalFractions}
              onChange={(e) => setTotalFractions(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label>Price per Fraction</Label>
            <Input
              type="number"
              inputMode="numeric"
              placeholder="Enter price per fraction"
              value={pricePerFraction}
              onChange={(e) => setPricePerFraction(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <Button variant="outline" onClick={handleCloseModal} disabled={loading}>
            Cancel
          </Button>
          <Button
            disabled={
              loading ||
              !totalFractions ||
              !pricePerFraction ||
              Number(totalFractions) <= 0 ||
              Number(pricePerFraction) <= 0
            }
            onClick={handleSubmit}
          >
            Fractionalize
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
